import React, { FC, useEffect, useState } from "react";
import { Card, Upload, Button, Tooltip } from "antd";
import { EyeOutlined, UploadOutlined } from "@ant-design/icons";

type DocumentUploadBillAuditStageProps = {
  documentTypes: any[];
  documentUrls: any[];
  handleFileChange: any;
  handleOpen: any;
  uploadFileList: any;
  disabled: boolean;
  selectedRoomType: any;
  selectedHospitalRoomType: any;
  isTPA: any;
  billAuditStageStatus: boolean;
  billSummaryLink: any;
  isFinalBillUploaded: any;
};

const DocumentUploadBillAuditStage: FC<DocumentUploadBillAuditStageProps> = ({
  documentTypes,
  documentUrls,
  handleFileChange,
  handleOpen,
  uploadFileList,
  disabled,
  selectedRoomType,
  selectedHospitalRoomType,
  isTPA,
  billAuditStageStatus,
  billSummaryLink,
  isFinalBillUploaded
}) => {
  const groupByLabelType = (docs: any[]) => {
    return docs?.reduce((acc: any, doc: any) => {
      const label = doc.documentLabelType;
      if (!acc[label]) acc[label] = [];
      acc[label].push(doc);
      return acc;
    }, {});
  };

  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "16px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        Document Upload
      </div>
      {/* {isTPA && !selectedHospitalRoomType && !selectedRoomType && (
        <div style={{ color: "red" }}>
          * Please select both room types to enable document upload
        </div>
      )} */}
      {/* {isTPA && !selectedHospitalRoomType && (
        <div style={{ color: "red" }}>
          * Please select hospital room type to enable document upload
        </div>
      )} */}
      {isTPA && !selectedRoomType && (
        <div style={{ color: "red" }}>
          * Please select scheme room type to enable document upload
        </div>
      )}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 10,
          //   opacity: !portalSubmission ? 1 : 0.5,
          //   pointerEvents: !portalSubmission ? 'auto' : 'none',
        }}
      >
        {documentTypes?.length > 0 &&
          documentTypes?.filter((docType) => docType?.visible)?.map((docType: any) => {
            //documentTypes?.map((docType: any) => {
            const matchingDocuments = documentUrls?.filter(
              (doc) => doc.documentLabelType === docType.label,
            );

            const isBillSummary = documentUrls?.find((doc) => doc?.documentLabelType?.toUpperCase() === "BILL SUMMARY");
            const isFinalBill = documentUrls?.find((doc) => doc?.documentLabelType?.toUpperCase() === "FINAL BILL")

            if (matchingDocuments?.length > 0 && !docType?.multiple) {
              return null;
            }

            return (
              <div
                key={docType.id}
                style={{
                  border: "1px solid #eee",
                  padding: 10,
                  borderRadius: 8,
                  display: "flex",
                  alignItems: "center",
                  // gap: 8,
                }}
              >
                {matchingDocuments?.length > 0 && !docType?.multiple ? (
                  <p></p>
                ) : (
                  <Upload
                    multiple={docType?.multiple}
                    // multiple={false}
                    {...(docType?.multiple ? { fileList: uploadFileList } : {})}
                    showUploadList={false}
                    beforeUpload={() => false}
                    onChange={
                      handleFileChange &&
                      handleFileChange(docType?.labelId, docType?.multiple) //docType?.multiple
                    }
                    disabled={
                      disabled ||
                      (billAuditStageStatus &&
                        docType?.label?.toUpperCase() === "HOSPITAL BILL") || (docType?.label?.toUpperCase() === "FINAL BILL" && (!isBillSummary || !isFinalBillUploaded))
                    }
                  >
                    <Button
                      icon={<UploadOutlined />}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        borderRadius: 0,
                        border: "none",
                        borderTopLeftRadius: "6px",
                        borderBottomLeftRadius: "6px",
                      }}
                      disabled={
                        // (isTPA && !selectedHospitalRoomType) ||
                        (isTPA && !selectedRoomType) || (docType?.label?.toUpperCase() === "FINAL BILL" && (!isBillSummary || !isFinalBillUploaded)) ||
                        docType?.label?.toUpperCase() === "BILL SUMMARY" ||
                        (billAuditStageStatus &&
                          docType?.label?.toUpperCase() === "HOSPITAL BILL")
                          ? true
                          : disabled
                      }
                      // disabled={docType?.label?.toUpperCase() === "BILL SUMMARY" ? true : disabled}
                    ></Button>
                  </Upload>
                )}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    style={{
                      borderRadius: 0,
                      border: "none",
                      paddingLeft: 4,
                      borderTopRightRadius: "6px",
                      borderBottomRightRadius: "6px",
                    }}
                    iconPosition={"end"}
                  >
                    <Tooltip title={docType?.label}>
                      <span>
                        {docType?.label?.length > 25
                          ? docType.label.substring(0, 25) + "..."
                          : docType.label}
                      </span>
                    </Tooltip>

                    {docType?.required ? (
                      <span style={{ color: "red" }}>*</span>
                    ) : (
                      <></>
                    )}
                  </Button>
                </div>
              </div>
            );
          })}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 10,
          borderTop: documentUrls?.length > 0 ? "1px solid gray" : "none",
        }}
      >
        {Object.entries(groupByLabelType(documentUrls || []))?.map(
          ([labelType, docs]: [any, any]) =>
            docs.map((docType: any, idx: any) => (
              <div
                key={docType.id}
                style={{
                  border: "1px solid #eee",
                  padding: 10,
                  borderRadius: 8,
                  display: "flex",
                  alignItems: "center",

                  // gap: 8,
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    style={{
                      borderRadius: "6px",
                      border: "none",
                      paddingLeft: 20,
                      // borderTopRightRadius: "6px",
                      // borderBottomRightRadius: "6px",
                      background: docType?.deficiencyCheckStatus
                        ? "rgb(0, 109, 119)"
                        : docType?.deficiencyCheckStatus === "false" ||
                            docType?.deficiencyCheckStatus === false
                          ? "#DD2025"
                          : "#fff",
                      color:
                        docType?.deficiencyCheckStatus ||
                        docType?.deficiencyCheckStatus === false
                          ? "white"
                          : "black",
                    }}
                    iconPosition={"end"}
                    icon={
                      <EyeOutlined
                        style={{ marginLeft: "0.6rem" }}
                        onClick={() => {
                          handleOpen(
                            docType?.documentLabelType,
                            docType?.documentUrl,
                          );
                        }}
                      />
                    }
                  >
                    {docType?.documentLabelType} {idx + 1}{" "}
                  </Button>
                </div>
              </div>
            )),
        )}
      </div>

      {/* {billSummaryLink ? (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 10,
            borderTop: documentUrls?.length > 0 ? "1px solid gray" : "none",
          }}
        >
          <div
            key={billSummaryLink}
            style={{
              border: "1px solid #eee",
              padding: 10,
              borderRadius: 8,
              display: "flex",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                style={{
                  borderRadius: "6px",
                  border: "none",
                  paddingLeft: 20,
                  background: "#fff",
                  color: "black",
                }}
                iconPosition={"end"}
                icon={
                  <EyeOutlined
                    style={{ marginLeft: "0.6rem" }}
                    onClick={() => {
                      handleOpen(
                        "BILL SUMMARY",
                        billSummaryLink,
                      );
                    }}
                  />
                }
              >
                {"BILL SUMMARY"} {1}{" "}
              </Button>
            </div>
          </div>
        </div>
      ) : null} */}
    </div>
  );
};

export default DocumentUploadBillAuditStage;
